// Mimics a border via inset box-shadow so layout doesn't shift when width changes between states.
export const insetBorder = (color: string, width = 1): string =>
  `inset 0 0 0 ${width}px ${color}`;
